export default __webpack_public_path__ + "ab2b33617ea696cc31bc494037da79f0.svg";